var GaScroll = function(params){
    var _this = this,
        _pagesPassed  = {};

    function _isElemInView(elem){
        if (!elem){
            console.log('Please, pass a valid DOM element for an argument.');
            return false;
        }

        // return $(document).scrollTop() >= elem.offsetTop;
        return $(document).scrollTop() >= elem.clientHeight + elem.offsetTop;
        // return $(document).scrollTop() + window.innerHeight >= elem.offsetTop;
    }

    function _checkPageVisibility(){
        return dom.debounce(function(){
            var $page0 = $('.vr-mobile-body .vr-mobile-body__page-img-wrap:first')[0],
                $pagesBodyWrap = document.querySelector('.vr-mobile-body__wrap');

            if(typeof _pagesPassed.page0 === 'undefined' && _isElemInView($page0)){
                ga('send', 'event', 'scroll-view-' + (isMobile ? 'mobile' : 'desktop'), 'fifty', window.location.href);
                _pagesPassed.page0 = true;
            }

            if(typeof _pagesPassed.pagesBodyWrap === 'undefined' && _isElemInView($pagesBodyWrap)){
                ga('send', 'event', 'scroll-view-' + (isMobile ? 'mobile' : 'desktop'), 'seventy-five', window.location.href);
                // console.log('%c pagesBodyWrap passed', 'color: blue');
                _pagesPassed.pagesBodyWrap = true;
            }

            if(typeof _pagesPassed.bodyEnd === 'undefined' && Math.ceil($(document).scrollTop() + window.innerHeight) >= $(document).height() - 10){ //added some buffer when scrolling to the bottom
                ga('send', 'event', 'scroll-view-' + (isMobile ? 'mobile' : 'desktop'), 'hundred', window.location.href);
                _pagesPassed.bodyEnd = true;
            }
            
        }, 150);
    }
    

    function _handleScroll(){
        $(document).on('scroll', _checkPageVisibility());
    }
    

    function _init(){
        _handleScroll();
    }

    _init();

    _this.init = _init;
};